import React, { Component, Suspense } from 'react';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';

const LazyPrivacyPolicyRoutes = React.lazy(() => import(/* webpackChunkName: "privacyPolicy" */ './PrivacyPolicy')
);

const SuspenseWrapperProvacyPolicy = props => (
  <Suspense fallback={<ActivityIndicator.FullScreenV2 />}>
    <LazyPrivacyPolicyRoutes {...props} />
  </Suspense>
);

export default class PrivacyPolicyWrapper extends Component {
  render() {
    return <SuspenseWrapperProvacyPolicy />;
  }
}
